enum FilterPopoverTabs {
  Whitelabels,
  Clients,
  Advertisers,
}

export default FilterPopoverTabs;
